import Loadable from 'react-loadable';

export const PartnerEndpointGroupsContainer = Loadable({
  loader: () => import('./PartnerEndpointGroups'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./src/containers/PartnerEndpointGroupsManager/index.ts